import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { CustomControlContent } from './types';
export const LegacyCustomControlProvider = memo(function LegacyCustomControlProvider(props) {
    const { children, custom_control_config } = props;
    const { loading, fail, current_label, action_label, state_value, is_active } = custom_control_config;
    const custom_control_state = useMemo(() => ({
        loading,
        fail,
        current_label,
        action_label,
        state_value,
        is_active,
    }), [loading, fail, current_label, action_label, is_active, state_value]);
    const custom_control = useMemo(() => ({
        ...custom_control_config,
        ...custom_control_state,
    }), [custom_control_config, custom_control_state]);
    return (_jsx(CustomControlContent.Provider, { value: custom_control, children: children }));
});
